// Sync failure reasons stored before the plain wording (SyncFailure.cs) read the same as new ones.
const LEGACY_REASONS = [
  [/^Graph returned 404 for the call record/, 'Microsoft returned no call record for this call'],
  [/^Call record throttled \(429\) during sync/, 'Microsoft limited requests during sync'],
  [/^Graph returned \d+ during sync/, 'Microsoft returned an error during sync'],
  [/^Graph returned \d+ for the call record/, 'Microsoft refused the request for this call record'],
  [/^Graph did not answer during sync/, 'Microsoft did not answer during sync'],
];

/** A PSTN difference reason in plain words; reasons already worded that way pass through. */
export function plainSyncReason(reason) {
  if (!reason) return reason;
  const match = LEGACY_REASONS.find(([pattern]) => pattern.test(reason));
  return match ? reason.replace(match[0], match[1]) : reason;
}
